import React from 'react';
import './QAFormPrint.scss';
import QaFormTable from "./QaFormTable";
import HeaderPrint from "../HeaderPrint/HeaderPrint";

const QAFormPrint = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className='qa_form'>
              <HeaderPrint
                persianTitle={"فرم QA"}
                englishTitle={"QA  form"}
                color={"#0672B0"}
              />
              <div className='form_info'>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>فرم ها :</span>
                    <span className='iransans'>{item.form}</span>
                  </div>
                  <div className='box_child'>
                    <span className='iransans'>کد QA :</span>
                    <span className='iransans'>{item.QACode}</span>
                  </div>
                </div>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>تاریخ :</span>
                    <span className='iransans'>{item.date}</span>
                  </div>
                  <div className='box_child'>
                    <span className='iransans'>ورژن :</span>
                    <span className='iransans'>{item.version}</span>
                  </div>
                </div>
              </div>
              <QaFormTable frontend={item.frontend} backend={item.backend}/>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default QAFormPrint;